module.exports = __webpack_public_path__ + "images/0666c3dbf3bdcc818258e46b090c4eb7-NPS-Transparent-Logo__1598367821603.png";